import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material'
import { filterButtonSx } from '../../common/sharedStyles'
import { PERIOD_RE } from './archivalUtils'

/**
 * Pick the month to bring back from S3 into the Archive collection. Submitting hands the period to the page,
 * which asks for a final confirmation before queuing the S3 → WARM run.
 */

/** Previous calendar month as YYYY-MM: the latest month that can be rehydrated. */
function lastMonth() {
    const d = new Date()
    d.setDate(1)
    d.setMonth(d.getMonth() - 1)
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

export default function RehydrateDialog({ open, item, onCancel, onSubmit }) {
    const [period, setPeriod] = useState('')
    useEffect(() => { if (open) setPeriod('') }, [open])

    const value = period.trim()
    const isPeriod = PERIOD_RE.test(value)
    const valid = isPeriod && value <= lastMonth()
    const s3 = item?.summary?.s3

    return (
        <Dialog open={open} onClose={onCancel} maxWidth='xs' fullWidth>
            <DialogTitle sx={{ fontWeight: 700, pb: 0.5 }}>Rehydrate month</DialogTitle>
            <DialogContent>
                <Typography variant='body2' sx={{ fontFamily: 'monospace', color: 'text.secondary', mb: 1 }}>{item?.collectionName}</Typography>
                <Typography variant='body2' sx={{ color: 'text.secondary', mb: 2 }}>
                    Copies one month back from S3 into <b>{item?.warmCollectionName || `${item?.collectionName}_archive`}</b>.
                    {s3?.oldestPeriod && ` S3 holds ${s3.oldestPeriod} → ${s3.newestPeriod || s3.oldestPeriod}.`}
                </Typography>
                <TextField
                    autoFocus
                    fullWidth
                    size='small'
                    type='month'
                    label='Month (YYYY-MM)'
                    placeholder='YYYY-MM'
                    InputLabelProps={{ shrink: true }}
                    value={period}
                    inputProps={{ max: lastMonth() }}
                    onChange={(e) => setPeriod(e.target.value)}
                    error={Boolean(value) && !valid}
                    helperText={value && !isPeriod ? 'Use the format YYYY-MM' : value && !valid ? 'Pick a past month' : ' '}
                />
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button size='small' sx={filterButtonSx('reset')} onClick={onCancel}>Cancel</Button>
                <Button size='small' variant='contained' disabled={!valid} onClick={() => onSubmit(value)} sx={{ textTransform: 'none', fontWeight: 600 }}>
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    )
}
